// Stripe Connect account disabled_reason codes -> user-friendly messages (from Stripe API docs)
export const STRIPE_DISABLED_REASON_MESSAGES = {
  "action_required.requested_capabilities":
    "Your Stripe account needs additional setup. Request the required capabilities to enable payments.",
  listed:
    "Your Stripe account is under review. Stripe may have identified a potential match with a restricted list. Contact Stripe support for more information.",
  other:
    "Your Stripe account has been restricted. Visit your Stripe dashboard for details or contact Stripe support.",
  platform_paused:
    "Your Stripe account has been paused. Contact support for assistance.",
  "rejected.fraud":
    "Your Stripe account was restricted due to suspected fraud. Contact Stripe support to resolve this.",
  "rejected.incomplete_verification":
    "Your Stripe account was rejected for incomplete verification. Complete the required verification in your Stripe dashboard.",
  "rejected.listed":
    "Your Stripe account was rejected because it may be on a restricted list. Contact Stripe support for more information.",
  "rejected.other":
    "Your Stripe account was rejected. Contact Stripe support for details on how to resolve this.",
  "rejected.platform_fraud":
    "Your account was restricted by the platform. Contact support for assistance.",
  "rejected.platform_other":
    "Your account was restricted by the platform. Contact support for assistance.",
  "rejected.platform_terms_of_service":
    "Your account was restricted for violating our terms of service. Contact support for assistance.",
  "rejected.terms_of_service":
    "Your Stripe account was rejected for not meeting Stripe's terms of service. Contact Stripe support for details.",
  "requirements.past_due":
    "You have overdue requirements in Stripe. Complete them in your Stripe dashboard to enable payments.",
  "requirements.pending_verification":
    "Stripe is verifying your account information. This usually takes 24–48 hours. You'll be able to collect payments once verification is complete.",
  under_review:
    "Your Stripe account is under review. This usually takes 24–48 hours. You'll be able to collect payments once the review is complete.",
};

// Stripe requirement field names -> human-readable labels
const STRIPE_FIELD_LABELS = {
  "business_profile.url": "Business website URL",
  "business_profile.mcc": "Business category (MCC)",
  "business_profile.product_description": "Product or service description",
  "individual.first_name": "First name",
  "individual.last_name": "Last name",
  "individual.dob.day": "Date of birth (day)",
  "individual.dob.month": "Date of birth (month)",
  "individual.dob.year": "Date of birth (year)",
  "individual.address.line1": "Address",
  "individual.address.city": "City",
  "individual.address.state": "State",
  "individual.address.postal_code": "Postal code",
  "individual.address.country": "Country",
  "individual.verification.document": "ID document",
  "individual.verification.document.front": "ID document (front)",
  "individual.verification.document.back": "ID document (back)",
  "individual.id_number": "Government ID number",
  "company.name": "Company name",
  "company.tax_id": "Company tax ID",
  "company.address.line1": "Company address",
  "company.verification.document": "Company verification document",
  "external_account": "Bank account",
  "tos_acceptance.date": "Terms of service acceptance",
};

export function formatStripeFieldLabel(field) {
  return (
    STRIPE_FIELD_LABELS[field] ??
    field
      .split(/[._]/)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ")
  );
}

const DEFAULT_DISABLED_MESSAGE =
  "Your Stripe account has a restriction. Visit your Stripe dashboard for details.";

export function getStripeBannerMessage(
  disabledReason,
  phase,
  phaseMessages
) {
  if (disabledReason) {
    return (
      STRIPE_DISABLED_REASON_MESSAGES[disabledReason] ?? DEFAULT_DISABLED_MESSAGE
    );
  }
  return phaseMessages[phase];
}
